import React, { useContext } from 'react';
import { Button } from 'antd';

import ButtonCreateStaticActivity from '@totem/components/ticketing/details/activities/buttonCreateStaticActivity';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { isNull } from '@totem/utilities/common';

const styles = {
  button: {
    fontSize: '36px',
    marginLeft: '0.5em',
  },
};

type Props = {
  buttonProps?: Omit<
    React.ComponentProps<typeof Button>,
    'onClick' | 'disabled' | 'children'
  >;
};

const UpdateButton = ({ buttonProps }: Props) => {
  const { ticket, activityConfiguration } = useContext(TicketContext);

  if (
    isNull(ticket) ||
    ticket.ticket.status !== 'OPEN' ||
    isNull(activityConfiguration) ||
    activityConfiguration.findIndex(
      (chk) => chk.id === '00000055f3329dc06f000005', // Code == RESOLVE
    ) === -1
  ) {
    return null;
  }

  return (
    <div style={styles.button}>
      <ButtonCreateStaticActivity
        activityId={'00000055f3329dc06f000005'}
        title={'Update / Follow-up'}
        buttonProps={buttonProps}
      />
    </div>
  );
};

export default UpdateButton;
